
import { FormPage } from "../../types/form";

export const page3Config: FormPage = {
  page: 3,
  elements: [
    {
      id: "section_development_info",
      type: "section_header",
      label: "ข้อมูลการส่งพัฒนาการ"
    },
    {
      id: "worksheet_search",
      type: "worksheet_search",
      label: "ค้นหาหัวข้อที่น้องเรียน",
      name: "worksheet_search",
      targetField: "topic_learned",
      description: "ค้นหาหัวข้อเรียน เมื่อเลือกแล้วจะกรอกในช่องหัวข้อโดยอัตโนมัติ"
    },
    {
      id: "topic_learned",
      type: "text",
      label: "วันนี้น้องเรียนเรื่อง :",
      name: "topic_learned",
      required: true
    },
    {
      id: "knowledge_rating",
      type: "radio",
      label: "ระดับพัฒนาการในมิติความรู้ (Knowledge)",
      name: "knowledge_rating",
      required: true,
      description: "(ให้คะแนน 1-5 พร้อมพฤติกรรมที่สังเกตได้)",
      options: [
        { value: 5, label: "5 คะแนน = ระดับเชี่ยวชาญ (Mastery)" },
        { value: 4, label: "4 คะแนน = ระดับเข้าใจดี (Proficient)" },
        { value: 3, label: "3 คะแนน = ระดับปานกลาง (Developing)" },
        { value: 2, label: "2 คะแนน = ระดับต้องปรับปรุง (Emerging)" },
        { value: 1, label: "1 คะแนน = ระดับยังไม่เข้าใจ (Beginning)" }
      ]
    },
    {
      id: "knowledge_behavior",
      type: "textarea",
      label: "พฤติกรรมที่สะท้อนถึงคะแนนในมิติความรู้ (Knowledge)",
      name: "knowledge_behavior",
      required: true,
      description: "(ระบุพฤติกรรมของน้องที่สอดคล้องกับคะแนน อย่างน้อย 50 ตัวอักษร)"
    },
    {
      id: "skills_rating",
      type: "radio",
      label: "ระดับพัฒนาการในมิติทักษะ (Skills)",
      name: "skills_rating",
      required: true,
      description: "(ให้คะแนน 1-5 พร้อมพฤติกรรมที่สังเกตได้)",
      options: [
        { value: 5, label: "5 คะแนน = ระดับเชี่ยวชาญ (Mastery)" },
        { value: 4, label: "4 คะแนน = ระดับเข้าใจดี (Proficient)" },
        { value: 3, label: "3 คะแนน = ระดับปานกลาง (Developing)" },
        { value: 2, label: "2 คะแนน = ระดับต้องปรับปรุง (Emerging)" },
        { value: 1, label: "1 คะแนน = ระดับยังไม่เข้าใจ (Beginning)" }
      ]
    },
    {
      id: "skills_behavior",
      type: "textarea",
      label: "พฤติกรรมที่สะท้อนถึงคะแนนในมิติทักษะ (Skills)",
      name: "skills_behavior",
      required: true,
      description: "(ระบุพฤติกรรมของน้องที่สอดคล้องกับคะแนน อย่างน้อย 50 ตัวอักษร)"
    },
    {
      id: "attitude_rating",
      type: "radio",
      label: "ระดับพัฒนาการในมิติทัศนคติ (Attitude)",
      name: "attitude_rating",
      required: true,
      description: "(ให้คะแนน 1-5 พร้อมพฤติกรรมที่สังเกตได้)",
      options: [
        { value: 5, label: "5 คะแนน = ระดับเชี่ยวชาญ (Mastery)" },
        { value: 4, label: "4 คะแนน = ระดับเข้าใจดี (Proficient)" },
        { value: 3, label: "3 คะแนน = ระดับปานกลาง (Developing)" },
        { value: 2, label: "2 คะแนน = ระดับต้องปรับปรุง (Emerging)" },
        { value: 1, label: "1 คะแนน = ระดับยังไม่เข้าใจ (Beginning)" }
      ]
    },
    {
      id: "attitude_behavior",
      type: "textarea",
      label: "พฤติกรรมที่สะท้อนถึงคะแนนในมิติทัศนคติ (Attitude)",
      name: "attitude_behavior",
      required: true,
      description: "(ระบุพฤติกรรมของน้องที่สอดคล้องกับคะแนน อย่างน้อย 50 ตัวอักษร)"
    },
    {
      id: "student_improvement",
      type: "textarea",
      label: "สำหรับวันนี้น้องมีพัฒนาการที่เพิ่มขึ้นคือ:",
      name: "student_improvement",
      required: true,
      description: "(ระบุพฤติกรรมที่น้องพัฒนาขึ้นจากคลาสก่อนหน้านี้)"
    },
    {
      id: "problems_encountered",
      type: "checkbox",
      label: "ปัญหาที่เกิดกับน้องในการเรียน :",
      name: "problems_encountered",
      required: true,
      description: "[ระบุปัญหาที่พบในการเรียนคลาสนั้น ๆ สามารถระบุได้มากกว่า 1 ข้อ]",
      options: [
        { value: "ตีความโจทย์ผิด / ไม่เข้าใจคำถาม", label: "ตีความโจทย์ผิด / ไม่เข้าใจคำถาม" },
        { value: "คำนวณผิดพลาดในขั้นตอนพื้นฐาน", label: "คำนวณผิดพลาดในขั้นตอนพื้นฐาน (คณิต, ฟิสิกส์, เคมี)" },
        { value: "ขาดความมั่นใจในการตอบ", label: "ขาดความมั่นใจในการตอบ" },
        { value: "เร่งรีบ ไม่ตรวจสอบคำตอบ", label: "เร่งรีบ ไม่ตรวจสอบคำตอบ" },
        { value: "ฟังโจทย์ไม่ละเอียด อ่านจับใจความผิดพลาด", label: "ฟังโจทย์ไม่ละเอียด อ่านจับใจความผิดพลาด (ภาษาอังกฤษ, วิทยาศาสตร์)" },
        { value: "สับสนไวยากรณ์หรือโครงสร้างภาษา", label: "สับสนไวยากรณ์หรือโครงสร้างภาษา (ภาษาอังกฤษ)" },
        { value: "สมาธิสั้น มีสิ่งรบกวนระหว่างเรียน", label: "สมาธิสั้น มีสิ่งรบกวนระหว่างเรียน" },
        { value: "Other", label: "Other:", hasTextInput: true, textInputName: "problems_encountered_other" }
      ]
    },
    {
      id: "solutions_applied",
      type: "checkbox",
      label: "แนวทางที่ใช้แก้ไขในคลาส",
      name: "solutions_applied",
      required: true,
      description: "[ระบุวิธีที่ใช้แก้ปัญหาในการเรียนคลาสนั้น ๆ สามารถระบุได้มากกว่า 1 ข้อ]",
      options: [
        { value: "อธิบายซ้ำโดยใช้วิธีอื่น", label: "อธิบายซ้ำโดยใช้วิธีอื่น เช่น ยกตัวอย่างจากชีวิตจริง" },
        { value: "ให้ทำแบบฝึกหัดเพิ่มเติม", label: "ให้ทำแบบฝึกหัดเพิ่มเติมในส่วนที่ยังสับสน" },
        { value: "ใช้คำถามปลายเปิด", label: "ใช้คำถามปลายเปิดเพื่อกระตุ้นการคิด" },
        { value: "ให้ทำโจทย์แบบมีลำดับขั้น", label: "ให้ทำโจทย์แบบมีลำดับขั้น เพื่อช่วยให้เข้าใจที่มาที่ไป" },
        { value: "อธิบายความเชื่อมโยงกับวิชาอื่น", label: "อธิบายความเชื่อมโยงกับวิชาอื่น เช่น คณิต + ฟิสิกส์, ภาษาอังกฤษ + วิทยาศาสตร์" },
        { value: "Other", label: "Other:", hasTextInput: true, textInputName: "solutions_applied_other" }
      ]
    },
    {
      id: "homework",
      type: "textarea",
      label: "การบ้านหรือแบบฝึกหัดที่ให้กับน้องในวันนี้คือ :",
      name: "homework_assigned",
      required: true
    },
    {
      id: "next_topic_worksheet_search",
      type: "worksheet_search",
      label: "ค้นหาหัวข้อถัดไปที่จะเรียน",
      name: "next_topic_worksheet_search",
      targetField: "next_topic",
      description: "ค้นหาหัวข้อที่จะเรียนถัดไป เมื่อเลือกแล้วจะกรอกในช่องเรื่องถัดไปโดยอัตโนมัติ"
    },
    {
      id: "next_topic",
      type: "textarea",
      label: "เรื่องถัดไปที่จะเรียน",
      name: "next_topic",
      required: true
    }
  ]
};
